define('gigaset_csp/components/support/detail/faq',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/components/PubSubHub",
	"cartware/jquery/bem",
	"text!shoptheme/templates/magnific-popup/default.html",
	"gigaset/spinner",
	"magnific-popup"
], function(
	$,
	_,
	Component,
	PubSubHub,
	BEM,
	PopupHtml
) {
	var BLOCK = "csp-support-detail-faq";

	var popupTemplate = _.template(PopupHtml);

	return Component.create({
		block: null,
		product: null,

		$init: function() {
			this.block = BEM.block(BLOCK);
			this.product = this.block.data("product");
			
			this.bindEvents();
		},

		bindEvents: function() {
			var self = this;
			var linkElements = [
				'div.' + BEM.buildElementClassname('csp-support-detail-faq-top-entries', 'link'),
				'div.' + BEM.buildElementClassname('csp-support-detail-faq-categorized', 'link'),
				'div.' + BEM.buildElementClassname('search-autocomplete-item', 'link'),
				'div.' + BEM.buildElementClassname('contentbridge-search-result', 'faq-link'),
				'#search-results-faqcontent ' + '.' + BEM.buildElementClassname('contentbridge-search-result', 'link')
			];

			$(document.body).on(
				"click",
				linkElements.join(","),
				function(e) {
					var link = $(this),
						href = link.data("href"),
						content;

					// Tracking call
					$.post(href);


					e.preventDefault();
					self.registerFaqView(href).then(function() {
						if (link.bemHasModifier("file")) {
							window.open(href, '_blank');
							return;
						}

						$.magnificPopup.open({
							items: {
								src: popupTemplate({
									title: link.text(),
									body: link.bemSiblings("content").html()
								}),
								type: 'inline'
							}
						});
					});
				}
			);
		},

		registerFaqView: function (faqUrl) {
			var deferred = $.Deferred();

			if (typeof faqUrl === "undefined" || faqUrl === "") {
				return deferred.resolve();
			}

			PubSubHub.emit("csp.support.detail.faq.view", {
				faqUrl: faqUrl,
				product: _.get(this, "product.name", null),
				deferred: deferred
			});

			return deferred.promise();
		}
	});
});
